import { Box, Tabs, Tab } from '@mui/material';
import React, { useState, useContext, useEffect, useCallback } from 'react';

import { TabPanel } from '../common';
import ActiveSentReferrals from './tabs/ActiveSentReferrals';
import ActiveReceivedReferrals from './tabs/ActiveReceivedReferrals';
import AuthContext from '../auth/context/AuthContext';
import { isEmpty } from 'lodash';

export default function ActiveReferrals({ history }) {
  const [uuid, setUuid] = useState({});
  const [isNurse, setIsNurse] = useState(false);
  const currentUser = useContext(AuthContext);

  const canSendReferrals = currentUser?.referral_permissions?.some(
    item => item.key === 'SEND_REFERRAL' && item.value
  );

  const hasReceivedTab = !isEmpty(currentUser) &&
    currentUser.clinic_providers > 0 &&
    currentUser.referral_permissions.some(item =>
      (item.key === "ACCEPT_REFERRAL" || item.key === "SCHEDULE_REFERRAL") && item.value
    );

  // Determine initial tab from URL or fallback to available tab
  const getInitialTab = () => {
    const params = new URLSearchParams(history.location.search);
    const tab = params.get('tab');

    if (tab === 'sent' && !canSendReferrals) return hasReceivedTab ? 'received' : null;
    if (tab === 'received' && !hasReceivedTab) return canSendReferrals ? 'sent' : null;

    if (!tab) return canSendReferrals ? 'sent' : hasReceivedTab ? 'received' : null;
    return tab;
  };

  const [value, setValue] = useState(getInitialTab);

  // Update tab state and URL
  const handleChange = useCallback(
    (event, newValue) => {
      setValue(newValue);
      const url = `${history.location.pathname}?tab=${newValue}`;
      history.replace(url);
    },
    [history],
  );

  useEffect(() => {
    if (!isEmpty(currentUser)) {
      setUuid(currentUser.uuid);
      setIsNurse(currentUser.role_id === 4);

      // If current tab is not allowed, force first available tab
      if (value === 'sent' && !canSendReferrals && hasReceivedTab) {
        handleChange(null, 'received');
      }
      if (value === 'received' && !hasReceivedTab && canSendReferrals) {
        handleChange(null, 'sent');
      }
    }
  }, [currentUser, value, handleChange, canSendReferrals, hasReceivedTab]);

  // If no tabs are available, render nothing
  if (!canSendReferrals && !hasReceivedTab) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="active"
          centered
          textColor="secondary"
        >
          {canSendReferrals && <Tab label="Active Sent Referrals" value="sent" />}
          {hasReceivedTab && <Tab label="Active Received Referrals" value="received" />}
        </Tabs>
      </Box>

      {canSendReferrals && value === 'sent' && (
        <TabPanel value={value} index="sent">
          <ActiveSentReferrals history={history} uuid={uuid} />
        </TabPanel>
      )}

      {hasReceivedTab && value === 'received' && (
        <TabPanel value={value} index="received">
          <ActiveReceivedReferrals history={history} uuid={uuid} isNurse={isNurse} />
        </TabPanel>
      )}
    </Box>
  );
}